/**
 * This is a Redux middleware that automatically cleans up pending requests
 * when async thunks complete (either successfully or with errors).
 * 
 * To use this middleware:
 * 1. Import it in your store configuration file
 * 2. Add it to the middleware chain when creating the store
 * 
 * Example:
 * ```
 * import { configureStore } from '@reduxjs/toolkit';
 * import { requestCleanupMiddleware } from './middlewares/requestCleanupMiddleware';
 * import rootReducer from './rootReducer';
 * 
 * const store = configureStore({
 *   reducer: rootReducer,
 *   middleware: (getDefaultMiddleware) => 
 *     getDefaultMiddleware().concat(requestCleanupMiddleware)
 * });
 * ```
 */

import { clearPendingRequest } from '../utils/thunkUtils';

export const requestCleanupMiddleware = store => next => action => {
  // Check if this is a fulfilled or rejected action from a thunk
  if (action.type.endsWith('/fulfilled') || action.type.endsWith('/rejected')) {
    const thunkPrefix = action.type.split('/').slice(0, -1).join('/');
    const { arg } = action.meta || {};
    
    if (arg) {
      // Clean up the pending request entry
      clearPendingRequest(thunkPrefix, arg);
    }
  }
  
  return next(action);
};
